import React from 'react';
import SEO from "@/components/SEO";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

const ServicesIndex = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO 
        title="Services Gestion Déchets Occitanie, Auvergne, Île-de-France | Groupe Fabre Environnement"
        description="Solutions complètes de gestion des déchets en Occitanie, Auvergne-Rhône-Alpes et Île-de-France : location bennes, achat métaux, démolition, recyclage pour particuliers, professionnels et collectivités."
        canonical="/services"
        keywords="gestion déchets Occitanie, recyclage Auvergne, location bennes Île-de-France, achat métaux Toulouse, démolition Aurillac, valorisation déchets Paris"
      />
      
      <Navbar />
      
      <main className="flex-grow pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-fabre-green via-fabre-teal to-fabre-darkgreen text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
                Nos Services de Gestion des Déchets
              </h1>
              <p className="text-xl leading-relaxed mb-8 opacity-90">
                Solutions complètes pour tous vos besoins de valorisation et recyclage en Occitanie, Auvergne-Rhône-Alpes et Île-de-France
              </p>
            </div>
          </div>
        </section>

        {/* Services par Type de Client */}
        <section className="py-20 bg-gradient-to-br from-white to-fabre-lightgreen/10">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-heading font-bold text-center text-fabre-gray mb-16">
              Services par Type de Client
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <Link to="/services/particuliers" className="group bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-fabre-green/10">
                <div className="text-4xl mb-4">🏠</div>
                <h3 className="text-xl font-bold text-fabre-darkgreen mb-3 group-hover:text-fabre-green transition-colors">
                  Particuliers
                </h3>
                <p className="text-fabre-darkteal mb-4">
                  Évacuation de déchets domestiques, débarras, rénovation
                </p>
                <div className="text-fabre-green font-medium group-hover:underline">
                  Découvrir nos solutions →
                </div>
              </Link>

              <Link to="/services/professionnels" className="group bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-fabre-teal/10">
                <div className="text-4xl mb-4">🏢</div>
                <h3 className="text-xl font-bold text-fabre-darkgreen mb-3 group-hover:text-fabre-teal transition-colors">
                  Professionnels
                </h3>
                <p className="text-fabre-darkteal mb-4">
                  Gestion des déchets d'entreprise, collecte régulière
                </p>
                <div className="text-fabre-teal font-medium group-hover:underline">
                  Nos solutions pro →
                </div>
              </Link>

              <Link to="/services/collectivites" className="group bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-fabre-darkgreen/10">
                <div className="text-4xl mb-4">🏛️</div>
                <h3 className="text-xl font-bold text-fabre-darkgreen mb-3 group-hover:text-fabre-darkgreen transition-colors">
                  Collectivités
                </h3>
                <p className="text-fabre-darkteal mb-4">
                  Partenariat public, gestion territoriale des déchets
                </p>
                <div className="text-fabre-darkgreen font-medium group-hover:underline">
                  Solutions publiques →
                </div>
              </Link>

              <Link to="/services/vehicules" className="group bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-fabre-green/10">
                <div className="text-4xl mb-4">🚗</div>
                <h3 className="text-xl font-bold text-fabre-darkgreen mb-3 group-hover:text-fabre-green transition-colors">
                  Véhicules
                </h3>
                <p className="text-fabre-darkteal mb-4">
                  Destruction automobile, récupération métaux véhicules
                </p>
                <div className="text-fabre-green font-medium group-hover:underline">
                  Destruction VHU →
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* Services Techniques */}
        <section className="py-20 bg-gradient-to-br from-fabre-lightgray/30 to-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-heading font-bold text-center text-fabre-gray mb-16">
              Nos Services Techniques
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <Link to="/nos-services/location-bennes" className="group bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex items-start gap-6">
                  <div className="text-5xl">🚛</div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-fabre-darkgreen mb-3 group-hover:text-fabre-green transition-colors">
                      Location de Bennes
                    </h3>
                    <p className="text-fabre-darkteal mb-4">
                      Bennes de 8m³ à 30m³ pour tous vos chantiers. Livraison et collecte rapides dans toute l'Occitanie.
                    </p>
                    <div className="text-fabre-green font-medium group-hover:underline">
                      Louer une benne →
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/nos-services/achat-metaux" className="group bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex items-start gap-6">
                  <div className="text-5xl">♻️</div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-fabre-darkgreen mb-3 group-hover:text-fabre-teal transition-colors">
                      Achat de Métaux
                    </h3>
                    <p className="text-fabre-darkteal mb-4">
                      Rachat de métaux ferreux et non-ferreux aux meilleurs prix. Pesée certifiée et paiement immédiat.
                    </p>
                    <div className="text-fabre-teal font-medium group-hover:underline">
                      Vendre des métaux →
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/nos-services/demolition" className="group bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex items-start gap-6">
                  <div className="text-5xl">🏗️</div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-fabre-darkgreen mb-3 group-hover:text-fabre-darkgreen transition-colors">
                      Démolition
                    </h3>
                    <p className="text-fabre-darkteal mb-4">
                      Démolition selective et éco-responsable. Tri et valorisation des matériaux sur site.
                    </p>
                    <div className="text-fabre-darkgreen font-medium group-hover:underline">
                      Services démolition →
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/valorisation" className="group bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex items-start gap-6">
                  <div className="text-5xl">🌱</div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-fabre-darkgreen mb-3 group-hover:text-fabre-green transition-colors">
                      Valorisation
                    </h3>
                    <p className="text-fabre-darkteal mb-4">
                      Transformation des déchets en nouvelles ressources. Économie circulaire et développement durable.
                    </p>
                    <div className="text-fabre-green font-medium group-hover:underline">
                      Processus valorisation →
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* Zones d'Intervention */}
        <section className="py-20 bg-gradient-to-r from-fabre-green/10 to-fabre-teal/10">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-heading font-bold text-fabre-gray mb-8">
                Nos Régions d'Intervention
              </h2>
              <p className="text-xl text-fabre-darkteal mb-8 max-w-4xl mx-auto">
                Présents sur 3 grandes régions françaises, nous vous offrons un service de proximité adapté aux spécificités locales
              </p>
            </div>

            {/* Régions principales */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              {/* Occitanie */}
              <div className="bg-white rounded-xl p-8 shadow-lg border border-fabre-green/10">
                <h3 className="text-2xl font-bold text-fabre-darkgreen mb-4 text-center">🌅 Occitanie</h3>
                <p className="text-fabre-darkteal mb-6 text-center">Notre région historique depuis 1987</p>
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { code: "12", name: "Aveyron" },
                    { code: "30", name: "Gard" },
                    { code: "34", name: "Hérault" },
                    { code: "48", name: "Lozère" },
                    { code: "81", name: "Tarn" },
                    { code: "82", name: "Tarn-et-Garonne" },
                    { code: "11", name: "Aude" },
                    { code: "66", name: "Pyrénées-Orientales" }
                  ].map((dept) => (
                    <Link 
                      key={dept.code}
                      to={`/services/departement/${dept.code}`}
                      className="bg-fabre-lightgreen/20 rounded-lg p-3 text-center hover:bg-fabre-green/20 transition-colors border border-fabre-green/20"
                    >
                      <div className="font-bold text-fabre-darkgreen text-sm">{dept.code}</div>
                      <div className="text-xs text-fabre-darkteal">{dept.name}</div>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Auvergne-Rhône-Alpes */}
              <div className="bg-white rounded-xl p-8 shadow-lg border border-fabre-teal/10">
                <h3 className="text-2xl font-bold text-fabre-darkgreen mb-4 text-center">🏔️ Auvergne-Rhône-Alpes</h3>
                <p className="text-fabre-darkteal mb-6 text-center">Expansion vers notre territoire d'origine</p>
                <div className="grid grid-cols-1 gap-3">
                  <Link 
                    to="/services/departement/15"
                    className="bg-fabre-teal/20 rounded-lg p-3 text-center hover:bg-fabre-teal/30 transition-colors border border-fabre-teal/20"
                  >
                    <div className="font-bold text-fabre-darkgreen">15</div>
                    <div className="text-sm text-fabre-darkteal">Cantal</div>
                    <div className="text-xs text-fabre-darkteal mt-1">Siège historique Fabrude</div>
                  </Link>
                </div>
              </div>

              {/* Île-de-France */}
              <div className="bg-white rounded-xl p-8 shadow-lg border border-fabre-darkgreen/10">
                <h3 className="text-2xl font-bold text-fabre-darkgreen mb-4 text-center">🏛️ Île-de-France</h3>
                <p className="text-fabre-darkteal mb-6 text-center">Nouvelle implantation 2025</p>
                <div className="grid grid-cols-1 gap-3">
                  <Link 
                    to="/services/departement/95"
                    className="bg-fabre-darkgreen/20 rounded-lg p-3 text-center hover:bg-fabre-darkgreen/30 transition-colors border border-fabre-darkgreen/20"
                  >
                    <div className="font-bold text-fabre-darkgreen">95</div>
                    <div className="text-sm text-fabre-darkteal">Val-d'Oise</div>
                    <div className="text-xs text-fabre-darkteal mt-1">Profit Recyclage Paris</div>
                  </Link>
                </div>
              </div>
            </div>

            {/* Statistiques d'intervention */}
            <div className="bg-gradient-to-r from-fabre-green to-fabre-teal rounded-xl p-8 text-white text-center">
              <h3 className="text-2xl font-bold mb-6">Notre Couverture Territoriale</h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div>
                  <div className="text-3xl font-bold">3</div>
                  <div className="text-white/80">Grandes Régions</div>
                </div>
                <div>
                  <div className="text-3xl font-bold">10+</div>
                  <div className="text-white/80">Départements</div>
                </div>
                <div>
                  <div className="text-3xl font-bold">8</div>
                  <div className="text-white/80">Sites Implantés</div>
                </div>
                <div>
                  <div className="text-3xl font-bold">35+</div>
                  <div className="text-white/80">Années d'Expérience</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ServicesIndex;